import { Link } from "react-router-dom"
import AnimatedLetters from "../AnimatedLetters";
import './index.scss';
import { useEffect, useState } from 'react'
import Loader from "react-loaders";


const Home= ()=> {

    const [letterClass, setLetterClass]= useState('text-animate')
    const nameArray=[' ','U','d','a','y']
    const jobArray=['W','e','b',' ','D','e','v','e','l','o','p','e','r','.']

    useEffect(()=>{
         return()=> setTimeout(()=>{
           setLetterClass('text-animate-hover')

        }, 4000)
    },[])


    return(
        <>
        <div className="container home-page">
            <div className="text-zone">
            <h1>
                <span className={letterClass}>H</span>
                <span className={`${letterClass} _12`}>i,</span>
                 <br/> 
                 <span className={`${letterClass} _13`}>I</span>
                 <span className={`${letterClass} _14`}>'m</span>
           <AnimatedLetters 
           letterClass={letterClass}
           strArray={nameArray}
           idx={15}
           />
            <br/> 
            <AnimatedLetters
            letterClass={letterClass} 
            strArray={jobArray}
            idx={19}
           />
            </h1>
            <h2>MERN Developer/MongoDB/ Express/ React.js/ Node.js</h2>
            <Link to="/contact" className="flat-button">CONTACT ME</Link>
           
            </div>
            
        </div>
        <Loader type="pacman" />
        </>
    )
}

export default Home
